export const SPONSOR_TIER_FILTER_SCHEMA_ID = 'sponsorTier.name';

export const SPONSOR_TIER_FILTER_NAME = 'Sponsorship Level';

export const EXPLORE_PAGE_SIZE = 8;
export const FOLLOWING_PAGE_SIZE = 6;
export const SPONSOR_DIRECTORY_SEARCH_DEBOUNCE_MS = 500;
export const SPONSOR_DIRECTORY_FREE_TEXT_SEARCH_DEBOUNCE_MS = 500;
